import { Button } from "../../MUI";
import { ReactComponent as Icon } from "../../../assets/images/chat.svg";
import classes from "./index.module.scss";
import useMixpanel from "../../../hooks/useMixpanel";
import { mixpanelLiveChat } from "../../../constants/mixpanel";

export default function LiveChatButton() {
  const handleClick = () => {
    window.LiveChatWidget.call("maximize");
  };
  const { handleEventTrack } = useMixpanel();
  const { liveChatButton } = mixpanelLiveChat

  return (
    <>
      <Button
        onClick={(e) => {
          handleClick()
          handleEventTrack(e, liveChatButton)
        }
        }
        variant="outlined"
        className={`${classes.button} ${classes.button__desktop}`}
        startIcon={<Icon />}
      >
        Live chat
      </Button>
      <Button
        onClick={(e) => {
          handleClick()
          handleEventTrack(e, liveChatButton)
        }
        }
        variant="outlined"
        className={`${classes.button} ${classes.button__mobile}`}
      >
        <Icon />
      </Button>
    </>
  );
}
